{
  "instances": {
    "configprops": {
      "label": "Свойства конфигураций",

      "no_properties_set": "Нет установленных конфигураций"
    }
  }
}
